import {AfterViewInit, Component, Input, ViewEncapsulation} from '@angular/core';
import {CompositeFilterDescriptor, FilterDescriptor}        from '@progress/kendo-data-query';
import {FilterService}                                      from '@progress/kendo-angular-grid';
import {get}                                         from 'lodash';

type StatusFilterItem = {
  value: any;
  class: string;
};

@Component({
  selector: 'ap-checkbox-filter',
  templateUrl: './ap-checkbox-filter.component.html',
  styleUrls: ['./ap-checkbox-filter.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ApCheckboxFilterComponent implements AfterViewInit {
  @Input() public currentFilter: CompositeFilterDescriptor;
  @Input() public filterService: FilterService;
  @Input() public key;
  @Input() public items: any[];
  @Input() public filterClass: string;

  data: StatusFilterItem[] = [];
  value: any;

  constructor() {
  }

  ngAfterViewInit(): void {
    if (!this.items || this.items?.length === 0) {
      return;
    }
    this.data = this.items.reduce((acc: StatusFilterItem[], currentItem: any) => {
      const value = get(currentItem, this.key);
      const classValue = get(currentItem, this.filterClass);
      const exists = acc.some((item: StatusFilterItem) =>
        item.value === value && item.class === classValue
      );
      if (!exists) {
        acc.push({value, class: classValue});
      }
      return acc;
    }, [] as StatusFilterItem[]).sort((a, b) => b.value - a.value);
    this.value = this.currentFilter.filters.reduce((v: boolean, f: FilterDescriptor) => v && f.value, true);
    this.valueChange(this.value);
  }

  valueChange(value: any): void {
    this.filterService.filter({
      filters: [{
        field: this.key,
        operator: 'eq',
        value,
      }],
      logic: 'and'
    });
  }
}
